import React from 'react';
import { connect } from '../../redux/store';
import { actions } from '../../redux/modules/surveys';
import { compose, withProps } from 'recompose';
import { I18n } from '@kineticdata/react';
import { InfoMessage } from '@kineticdata/bundle-common';
import { PageTitle } from './PageTitle';

const SurveyConfirmationComponent = props => {
  const customFormText = props.form.attributes.filter(
    a => a.name === 'Confirmation Page Text' && a.values[0].length,
  );
  const customKappText = props.kapp.attributes.filter(
    a => a.name === 'Confirmation Page Text' && a.values[0].length,
  );
  const customText = customFormText[0]
    ? customFormText[0].values[0]
    : customKappText[0]
      ? customKappText[0].values[0]
      : null;

  return (
    <div className="page-container page-container--color-bar">
      <div className="page-panel">
        <PageTitle
          className="page-title-heading--sm"
          parts={['Survey Confirmation', 'My Surveys']}
          title="Survey Submitted"
          breadcrumbs={
            !!props.authenticated
              ? [
                  {
                    label: (
                      <span>
                        <span className="fa fa-fw fa-md fa-arrow-left text-muted" />
                        <I18n>My Surveys</I18n>
                      </span>
                    ),
                    to: `${props.appLocation}/my-surveys`,
                  },
                ]
              : undefined
          }
        />
        <div className="text-center">
          <I18n
            context={`kapps.${props.kappSlug}.forms.${props.slug}`}
            public={!props.authenticated}
          >
            <InfoMessage
              title={
                customText
                  ? customText
                  : 'Thank you for taking the time to complete this survey.'
              }
            />
          </I18n>
        </div>
      </div>
    </div>
  );
};

export const mapStateToProps = state => ({
  authenticated: state.app.authenticated,
  appLocation: state.app.location,
  kapp: state.app.kapp,
  surveys: state.surveyApp.forms,
  loading: state.surveyApp.loading,
});

export const mapDispatchToProps = {
  fetchSubmission: actions.fetchSubmissionRequest,
};

const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withProps(props => ({
    form:
      props.surveys && props.surveys.find(survey => survey.slug === props.slug),
  })),
);

export const SurveyConfirmation = enhance(SurveyConfirmationComponent);
